export const interiorA03ImageOptions = {
  angle: 'InteriorA03',
  staticOptions: {
    UpholsteryCabin: 1
  },
  mattes: [
    {
      option: 'UpholsteryCabin',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Xpower/views/InteriorA03.js